import React, { useState } from 'react';
import { 
  Gamepad2, 
  ShieldCheck, 
  CheckCircle2, 
  AlertTriangle,
  Info
} from 'lucide-react';

export const TeenShieldPage: React.FC = () => {
  const [checks, setChecks] = useState({
    roblox: true,
    discord: true,
    tfn: true,
    school: true
  });

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-950 text-purple-300 text-xs font-bold border border-purple-800">
          <Gamepad2 className="w-3.5 h-3.5" />
          <span>TEEN & CHILD IDENTITY HARDENING</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Teen Gaming & Social Media Footprint Shield</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Audit teenage gaming profiles (Roblox, Discord, Steam) and protect first Tax File Numbers from synthetic identity theft.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-4 shadow-xl text-xs">
        <h3 className="font-bold text-white text-sm">Parental Security Checklist:</h3>
        <div className="space-y-3">
          <div className="p-4 rounded-xl bg-slate-950 border border-slate-800 flex items-start gap-3">
            <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5" />
            <div>
              <div className="font-bold text-white">Enable 2FA on Gaming Accounts (Discord, Steam, Epic Games)</div>
              <p className="text-slate-400 text-[11px]">Prevents session token stealing and unauthorized credit card charges.</p>
            </div>
          </div>

          <div className="p-4 rounded-xl bg-slate-950 border border-slate-800 flex items-start gap-3">
            <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5" />
            <div>
              <div className="font-bold text-white">Lock First Tax File Number Paperwork</div>
              <p className="text-slate-400 text-[11px]">Store physical TFN letters in a home fireproof safe—never in school backpacks.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
